import { createContext } from 'react';

export type TranslationKey = string;
export type Translations = Record<TranslationKey, string>;

export const TranslationsContext = createContext<{ translations: Translations, prefix: string }>({ translations: {}, prefix: '' });
export const TranslationsProvider = TranslationsContext.Provider;
export default TranslationsContext;
